const ReportStatsActionTypes = {
  FETCH_REPORT_STATS_START: 'FETCH_REPORT_STATS_START',
  FETCH_REPORT_STATS_SUCCESS: 'FETCH_REPORT_STATS_SUCCESS',
  FETCH_REPORT_STATS_FAILED: 'FETCH_REPORT_STATS_FAILED',
  DESTROY_REPORT_STATS: 'DESTROY_REPORT_STATS',
};

export default ReportStatsActionTypes;
